<template>
  <div class="photoBackground" @mousedown="hideAuthBlock">
    <div class="closeAuth" @click="closeModal">
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 14L13.7279 1.27208" stroke="#2F2F2F" stroke-width="2" stroke-linecap="round" />
        <path d="M1 1L13.7279 13.7279" stroke="#2F2F2F" stroke-width="2" stroke-linecap="round" />
      </svg>
    </div>
    <div class="carousels">
      <div class="photoCarousel" v-if="girl.photos">
        <Flicking :options="{ align: 'center', panelsPerView: 1, circular: false, bound: true, inputType: ['mouse', 'pointer'], useResizeObserver: true, defaultIndex: photoIndex }" ref="photoCarousel">
          <div class="flicking-panel" v-for="(image, index) in girl.photos" :key="index">
            <img :src="image.url" alt="Gallery Image" class="gallery-image" :class="getImageClass(image)" />
          </div>
        </Flicking>
        <span @click="goToPrev" class="flicking-arrow-prev is-thin"></span>
        <span @click="goToNext" class="flicking-arrow-next is-thin"></span>
      </div>
      <div class="miniPhotoCarousel" v-if="girl.photos && !isMobile">
        <Flicking :options="{ align: 'center', panelsPerView: 16, circular: false, bound: true, transition: 100, useResizeObserver: false }" :plugins="carouselPlugins" ref="smallPhotoCarousel">
          <div class="flicking-mini-panel" v-for="(image, index) in girl.photos" :key="index" @click="goToSlide(index + 1)">
            <img :src="image.url" alt="Gallery Image" class="mini-gallery-image" />
          </div>
        </Flicking>
      </div>
    </div>
  </div>
</template>

<script>
import Flicking from "@egjs/vue3-flicking";
import { ref } from "vue";
export default {
  name: "PhotoView",
  data() {
    return {
      galleryConfig: {
        itemsToShow: 1,
        wrapAround: true,
        mouseDrag: false,
        touchDrag: false,
      },
      imageClasses: {},
      girl: this.girlPhotos,
      isFavouriteGirl: false,
      isReservationOpen: false,
      isMobile: false,
    };
  },
  props: { girlPhotos: Array, photoIndex: Number },
  components: {
    Flicking,
  },
  methods: {
    closeModal() {
      this.$emit("close-photo");
    },
    async onShowCarousel() {
      // await this.$nextTick()
      this.smallPhotoCarousel.resize();
    },
    goToSlide(index) {
      this.$refs.photoCarousel.moveTo(index - 1);
      console.log(index);
    },
    getImageClass(image) {
      const img = new Image();
      img.src = image.url;

      // Если класс уже определен, возвращаем его
      if (this.imageClasses[image.url]) {
        return this.imageClasses[image.url];
      }

      // Иначе загружаем изображение и определяем класс
      img.onload = () => {
        const className = img.width > img.height ? "landscape" : "portrait";
        this.imageClasses[image.url] = className; // Обновляем реактивное состояние
      };

      // Возвращаем временный класс (или ничего), пока изображение загружается
      return "";
    },
  },
  setup() {
    const photoCarousel = ref(0);
    const smallPhotoCarousel = ref(0);
    const goToPrev = () => {
      photoCarousel.value.prev().catch(() => void 0);
    };

    const goToNext = () => {
      photoCarousel.value.next().catch(() => void 0);
    };
    return { goToNext, goToPrev, photoCarousel, smallPhotoCarousel };
  },
  mounted() {
    setTimeout(() => {
      this.isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      console.log(123);
    }, 5);
    this.onShowCarousel();
  },
};
</script>
<style scoped>
.photoBackground {
  background-color: #232323e5;
  backdrop-filter: blur(8px);
  color: white;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 5002;
  display: flex;
  align-items: center;
  justify-content: center;
}
.photoCarousel {
  width: 50%;
  height: 100%;
  position: relative;
  margin: 0 auto;
}
.flicking-panel {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.carousel__icon) {
  fill: white;
  width: 30px;
  height: 30px;
}
:deep(.carousel__item) {
  width: 100%;
}
:deep(.carousel__next),
:deep(.carousel__prev) {
  fill: white;
  background-color: #2f2f2f80;
  border-radius: 40px;
  width: 40px;
  height: 40px;
}

:deep(.carousel__prev) {
  margin-left: -20px;
}
:deep(.carousel__next) {
  margin-right: -20px;
}
:deep(.carousel__item img) {
  width: 100%;
  max-height: 80vh;
  border-radius: 5px;
  object-fit: cover;
}
#thumbnails {
  margin-top: 10px;
}
.carousels {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 80%;
}
.miniPhotoCarousel {
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 15px;
}
.closeAuth {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2f2f2f;
  border-radius: 1rem;
  padding: 1%;
  cursor: pointer;
  background-color: white;
  position: absolute;
  right: 3vw;
  top: 15px;
}
.flicking-mini-panel {
  border-radius: 10px;
  height: 7vh;
  display: flex;
  justify-content: center;
}
.mini-gallery-image {
  height: 100%;
  width: 2vw;
  object-fit: cover;
  -webkit-user-drag: none;
  border-radius: 7px;
  cursor: pointer;
}
.gallery-image {
  /* height: 100%; */
  border-radius: 8px;
  /* width: 100%; */
  cursor: pointer;
  object-fit: cover;
  -webkit-user-drag: none;
}
.landscape {
  /* Стили для горизонтальной ориентации */
  width: 100%;
}

.portrait {
  /* Стили для вертикальной ориентации */
  height: 100%;
}
@media (max-width: 968px) {
  .photoCarousel {
    width: 100%;
  }
  .mini-gallery-image {
    width: 100%;
  }
  .closeAuth {
    padding: 3%;
  }
  .gallery-image {
    width: 100%;
  }
}
</style>
